import styled from"@emotion/styled";export const StyledNetworthItemUpdatedAtContainer=styled.div`
  background-color: ${props=>props.theme.colors.neutral100};
  padding: 8px 16px;
  border-radius: 8px;
  color: ${props=>props.theme.colors.neutral600};
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`;